import Service from '../Service'


const page = {
    getDataPage(data) {
        return Service.get('api/get-data-page?url='+data).then(res => res)
    }
};

export default page;
